import { ComponentProps } from "react";

import { Step } from "../../../../types/Step";
import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import FormSeriesMedicalStep, { IMedicalStepProps } from "../Components/FormSeriesMedicalStep";
import AllMedicalQuestionsEvaluator from "./AllMedicalQuestionsEvaluator";
import { AllMedicalQuestions } from "./ComposedAllMedicalQuestions";
import ComposedUseCreateMedicalNonCanLeadResult from "./ComposedUseCreateMedicalNonCanLeadResult";

const ConfiguredAllMedicalQuestionsStep: React.FC<IMedicalStepProps & IStepWrapperButtonProps> = props =>
  FormSeriesMedicalStep({
    ...props,
    nextStep: Step.scheduling,
    medicalQualificationEvaluator: AllMedicalQuestionsEvaluator,
    FormQuestions: AllMedicalQuestions,
    useCreateNonCandidateLeadResult: ComposedUseCreateMedicalNonCanLeadResult
  });

const ComposedAllMedicalQuestionsStep: React.FC<IStepWrapperButtonProps> = AppContextValueProvider<
  IMedicalStepProps,
  ComponentProps<typeof ConfiguredAllMedicalQuestionsStep>
>({
  Component: ConfiguredAllMedicalQuestionsStep,
  map: ({ medicalForm, router, setMedicalConclusions, setMedicalForm, triggerSaveCustomerNote }) => ({
    router,
    value: medicalForm,
    onMedicalNoncandidateDisqualification: triggerSaveCustomerNote,
    setMedicalConclusions,
    setMedicalFormState: setMedicalForm
  })
});

export default ComposedAllMedicalQuestionsStep;
